// extracted by mini-css-extract-plugin
export var addressFields = "_im-0";
export var animationContainer = "_im-1";
export var footer = "_im-2";
export var lineItems = "_im-3";
export var modalContent = "_im-4";
export var orderName = "_im-5";
export var strong = "_im-6";
export var warning = "_im-7";